module.exports = require("ieee754");


//////////////////
// WEBPACK FOOTER
// external "ieee754"
// module id = 522
// module chunks = 0